import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface HeaderState {
    value: {
        step: number | null,
        banner: boolean
    };
}

const initialState: HeaderState = {
    value: {
        step: null,
        banner: true
    }
}

export const headerSlice = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        selectFlowStep: (state, action: PayloadAction<number | null>) => {
            state.value.step = action.payload;
        },
    },
})

export const {selectFlowStep} = headerSlice.actions;

export default headerSlice.reducer;